import React, { useState } from 'react';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import './Stonks.css';
import MarketView from './MarketView';
import Transactions from './Transactions';
import Backtesting from './Backtesting';
import stonksLogo from './components/stonks.png';

const NAV_ITEMS = [
  { path: 'market',       label: 'Market View',  icon: '📊' },
  { path: 'transactions', label: 'Transactions', icon: '🧾' },
  { path: 'backtesting',  label: 'Backtesting',  icon: '📈' },
];

export default function Stonks() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="stonks-root">

      {/* ── Sidebar ──────────────────────────────────────────── */}
      <aside className={`stonks-sidebar${collapsed ? ' collapsed' : ''}`}>
        <div className="stonks-sidebar-header">
          <div className="stonks-logo-mark">
            <img src={stonksLogo} alt="Stonks" />
          </div>
          {!collapsed && (
            <span className="stonks-logo-text">Stonks</span>
          )}
        </div>

        <nav className="stonks-sidebar-nav">
          {NAV_ITEMS.map(item => (
            <NavLink
              key={item.path}
              to={`/stonks/${item.path}`}
              className={({ isActive }) =>
                `stonks-nav-item${isActive ? ' active' : ''}`
              }
              title={collapsed ? item.label : undefined}
            >
              <span className="stonks-nav-icon">{item.icon}</span>
              {!collapsed && item.label}
            </NavLink>
          ))}
        </nav>

        <div className="stonks-sidebar-footer">
          <button
            className="stonks-collapse-btn"
            onClick={() => setCollapsed(c => !c)}
            title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            <span style={{ fontSize: 14 }}>{collapsed ? '›' : '‹'}</span>
            {!collapsed && <span style={{ fontSize: 11 }}>Collapse</span>}
          </button>
        </div>
      </aside>

      {/* ── Main area ─────────────────────────────────────────── */}
      <div className="stonks-main">
        {/* Route content */}
        <div className="stonks-content">
          <Routes>
            <Route index element={<Navigate to="market" replace />} />
            <Route path="market" element={<MarketView />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="transactions/:sheetId" element={<Transactions />} />
            <Route path="backtesting" element={<Backtesting />} />
            <Route path="backtesting/:sheetId" element={<Backtesting />} />
          </Routes>
        </div>
      </div>

      {/* ── Mobile bottom nav ────────────────────────────────── */}
      <nav className="stonks-mobile-nav">
        {NAV_ITEMS.map(item => (
          <NavLink
            key={item.path}
            to={`/stonks/${item.path}`}
            className={({ isActive }) =>
              `stonks-mobile-nav-item${isActive ? ' active' : ''}`
            }
          >
            <span className="stonks-nav-icon">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
